// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface VideoDocumentModel {
    id: string;
    filename?: string;
    isYoutubeVideo?: boolean;
    link?: string;
    thumbnail?: string;
}

export type CustomProductState = {
    displayQtyAdjustedNotify: boolean;
};

export type xProductDetailsStateType = {
    displayQtyAdjustedNotify: boolean;
};

const initialState: xProductDetailsStateType = {
    displayQtyAdjustedNotify: false,
};

const xProductDetails = createTypedReducerWithImmer(initialState, {
    "xProductDetails/DisplayQtyAdjustedNotify": (
        draft: Draft<xProductDetailsStateType>,
        action: { displayQtyAdjustedNotify: boolean; },
    ) => {
        draft.displayQtyAdjustedNotify = action.displayQtyAdjustedNotify;
    },
});

export type xProductDetailsState = {
    xProductDetails: xProductDetailsStateType;
} & typeof reducers;

(reducers as any).xProductDetails = xProductDetails;
